import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import config from '@config';

const title = 'Prode Mundial 2026 - Página|12';
const desc =
  'El juego de Página|12 para predecir los resultados del Mundial de Fútbol 2026';
const host = String(config.host || '').replace(/\/$/, '');
const basePath = config.basePath || '';
const absoluteBasePath = `${host}${basePath}`;
const url = `${absoluteBasePath}/`;
const socialImage = `${absoluteBasePath}/img/prode-logo-26.png`;

export const BaseMetas = () => (
  <Helmet
    defaultTitle={title}
    titleTemplate="Prode Mundial 2026 - Página|12"
  >
    <html lang="es" translate="no" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta charset="utf-8" />
    <meta name="description" content={desc} />
    <meta property="fb:pages" name="fb:pages" content="1541638399393436" />
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="Prode Mundial 2026 - Página|12" />
    <meta name="google" content="notranslate" />

    <meta
      property="og:image"
      content={socialImage}
    />
    <meta
      name="twitter:image"
      content={socialImage}
    />

    <meta property="twitter:site" name="twitter:site" content="@pagina12" />
    <meta name="twitter:card" content="summary" />
    <meta
      property="twitter:creator"
      name="twitter:creator"
      content="@Pagina12"
    />

    <meta property="og:title" content={title} />
    <meta name="twitter:title" content={title} />

    <meta property="og:description" content={desc} />
    <meta name="twitter:description" content={desc} />

    <meta property="og:url" content={url} />
    <link rel="canonical" href={url} />

    <link
      rel="apple-touch-icon"
      sizes="180x180"
      href={`${config.basePath}/img/prode-logo-26.png`}
    />
    <link
      rel="icon"
      type="image/png"
      sizes="180x180"
      href={`${config.basePath}/img/prode-logo-26.png`}
    />

    <link rel="manifest" href={`${config.basePath}/manifest.json`} />

    <meta name="msapplication-TileColor" content="#000000" />
    <meta
      name="msapplication-square70x70logo"
      content={`${config.basePath}/icons/mstile-icon-128.png`}
    />
    <meta
      name="msapplication-square150x150logo"
      content={`${config.basePath}/icons/mstile-icon-270.png`}
    />
    <meta
      name="msapplication-square310x310logo"
      content={`${config.basePath}/icons/mstile-icon-558.png`}
    />
    <meta
      name="msapplication-wide310x150logo"
      content={`${config.basePath}/icons/mstile-icon-558-270.png`}
    />
    <meta name="theme-color" content="#000000" />
    <meta name="apple-mobile-web-app-capable" content="yes" />
  </Helmet>
);

BaseMetas.displayName = 'BaseMetas';

export const PageMetas = ({ title, description, path, mobileNarrow }) => (
  <Helmet>
    <title>{title}</title>
    <meta property="og:title" content={title} />
    <meta name="twitter:title" content={title} />

    <meta name="description" content={description} />
    <meta property="og:description" content={description} />
    <meta name="twitter:description" content={description} />

    <meta
      property="og:url"
      content={`${absoluteBasePath}/${path}`}
    />
    <link rel="canonical" href={`${absoluteBasePath}/${path}`} />

    <body className={mobileNarrow ? 'mobile-narrow' : ''} />
  </Helmet>
);

PageMetas.displayName = 'PageMetas';
PageMetas.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  path: PropTypes.string,
  mobileNarrow: PropTypes.bool,
};

PageMetas.defaultProps = {
  description: desc,
  path: '',
  mobileNarrow: false,
};

export default PageMetas;
